import ModalForm from "./Form";
import {FINANCEBOOK} from "../../../../Config/ApiUrl";
import {DATATABLE_EXPORT} from "../../../../Config/ApiUrl";

export const Schema = {
    components: {ModalForm},

    data() {
        return {
            DATATABLE_EXPORT,
            isAddEditModalActive: false,
            deleteConfirmationModalActive: false,
            deleteLoader: false,
            selectedUrl: this.ENDPOINT,
            tableId: 'finance-book-table',
            rowData: {},
            formId: 'finance-book-form',
            tableColumns : [
				{
					title: "Center",
					type: "custom-html",
					key: "center",
					isVisible: true,
					modifier: (value) => {
						return value ? value.name : ''
					},
					sortable: true,
				},
                {
                    title: 'Code',
                    type: 'text',
                    key: 'code',
            
                }
            ],
            ENDPOINT: FINANCEBOOK,
            actionObj : {
                title: this.$t('action'),
                type: 'action',
            },
            options: {
                name: 'FinanceBook',
                url: FINANCEBOOK,
                showHeader: true,
                enableHighlights: true,
                // enableRowSelect: true,
                enableSaveFilter: true,
                columns: [],
                actions: [
                    {
                        title: this.$t('edit'),
                        icon: 'edit',
                        type: 'none',
                        component: 'app-add-modal',
                        modalId: 'school-form',

                    },
                    {
                        title: this.$t('delete'),
                        icon: 'trash',
                        type: 'none',
                        component: 'app-confirmation-modal',
                        modalId: 'demo-delete',
                    }
                ],
                filters: [
                 
                ],
                showFilter: true,
                showSearch: true,
                showCount: true,
                showClearFilter: true,
                paginationType: "pagination",
                responsive: true,
                rowLimit: 10,
                showAction: true,
                orderBy: 'desc',
                actionType: "default",
            }
        }
    },
    methods: {
        /**
         * Delete confirmed $emit Form confirmation modal
         */
        onDelete() {
            let url = `${this.ENDPOINT}/${this.rowData.id}`;
            this.deleteLoader = true;
            this.axiosDelete(url)
                .then(response => {
                    this.deleteLoader = false;
                    $("#demo-delete").modal('hide');
                    this.onCancelDelete();
                    this.$toastr.s(response.data.message);
                    // this.searchAndSelectFilterOptions();
                })
                .catch(({err}) => {

                })
                .finally(() => this.$hub.$emit(`reload-${this.tableId}`))
        },
        onCancelDelete() {
            this.deleteConfirmationModalActive = false;
            this.reSetData();
        },
        reSetData() {
            this.rowData = {};
            this.selectedUrl = '';
        },
    }
}